export const SET_EDIT_DATA = "SET_EDIT_DATA";
export const RESET_EDIT_DATA = "RESET_EDIT_DATA";
export const INCOME_CATEGORY = [
    { name: "salary", value: "Salary" },
    { name: "freelancing", value: "Freelancing" },
    { name: "investments", value: "Investments" },
    { name: "stocks", value: "Stocks" },
    { name: "bitcoin", value: "Bitcoin" },
    { name: "bank Transfer", value: "Bank Transfer" },
    { name: "bank Interest", value: "Bank Interest" },
    { name: "youtube", value: "Youtube" },
    { name: "other", value: "Other" },
  ];
export const EXPENSE_CATEGORY = [
    { name: "food", value: "Food" },
    { name: "groceries", value: "Groceries" },
    { name: "shopping", value: "Shopping" },
    { name: "rent", value: "Rent" },
    { name: "travel", value: "Travel" },
    { name: "fuel", value: "Fuel" },
    { name: "other", value: "Other" },
  ];
export const SAVINGS_CATEGORY = [
    { name: "ppf", value: "PPF" },
    { name: "fd", value: "FD" },
    { name: "mutual funds", value: "Mutual Funds" },
    { name: "stocks", value: "Stocks" },
    { name: "other", value: "Other" },
  ];
export const MONTH_MAP = [
    "Month",
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUNE",
    "JULY",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];